<template>

<com-item name="players.overview" :size="size" :is-overview="3" :loading="loading" :is-empty="!active" title="Overview">

	<template v-slot:about>

		<p>Summary of {{ your }} plays with other players.</p>

	</template>

	<template v-slot:stats>

		<com-overview label="Players" type="number" :value="data.total" />

		<com-overview label="Total Plays" type="number" :value="data.plays" />

		<com-overview label="Games Played" type="number" :value="data.games" />

		<com-overview label="1:1 Players" type="number" :value="data.head2head" info="Played with you head to head." />

		<com-overview label="1:1 vs Group Plays" type="pie" :value="data.split" />

		<com-overview label="Group Combos" type="number" :value="data.groups" info="Unique combinations of players." />

		<com-overview label=">= 5 plays" type="number" :value="data.plays5" />

		<com-overview label=">= 10 plays" type="number" :value="data.plays10" />

		<com-overview label=">= 25 plays" type="number" :value="data.plays25" />

	</template>

</com-item>

</template>

<script>

import comOverview from './../common/Overview'
import comItem from './../common/Item'

export default {

	props: ['fetching', 'your', 'you', 'size', 'period'],

	components: {
		'com-item': comItem,
		'com-overview': comOverview
	},

	computed: {

		loading: function() {

			return this.fetching === 'all' 

		},

		data: function() {

			return this.$store.getters['page/insights/players/overview']

		},

		active: function() {

			return this.data && !this.loading

		},

		isYearly: function() {

			return this.period !== 'all'

		}

	}

}

</script>

<style scoped>

</style>